import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { CoverageCheckupState, stepReducer } from './step';

interface Store {
  steps: CoverageCheckupState;
}

const reducer = {
  reducer: { steps: stepReducer },
};

export function makeStore(): EnhancedStore<Store> {
  return configureStore(reducer);
}

const store = configureStore(reducer);

export type GetState = typeof store.getState;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export interface AppThunk {
  dispatch: AppDispatch;
  state: RootState;
}

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store };
